import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createAction,
  EntityState,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import {
  DashboardService,
  GetUserWidgetExternalResponse,
  GetUserWidgetExternalParams,
} from '@app/gen/dashboard';
import { ThunkExtra } from '@app/store';
import { DynamicEntity } from '@app/types';

import { DashboardState, External } from '../dashboard.state';

export const getExternal = createAsyncThunk<
  GetUserWidgetExternalResponse,
  GetUserWidgetExternalParams,
  ThunkExtra
>(
  'dashboard/getExternal',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getUserWidgetExternal({
        params,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const createExternalState = createAction<string>(
  'dashboard/createExternalState',
);

export const externalReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getExternal.pending, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'loading',
    };
  });
  builder.addCase(getExternal.fulfilled, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'complete',
      ...action.payload,
    };
  });
  builder.addCase(getExternal.rejected, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'failed',
    };
  });
  builder.addCase(createExternalState, (state, { payload }) => {
    if (!state.external[payload]) {
      state.external = {
        ...state.external,
        [payload]: {
          ...(state.external[payload] as External),
          status: 'loading',
        },
      };
    }
  });
};
